export default function Events() {
  return (
    <>
      <div>Events</div>
    </>
  );
}
